<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="thehistoryof16">
<h2 class="head">Social Composition and Status</h2>
<p class="para">Throughout the 18th and 19th centuries, officers held a distinguished social status in Russian society. One of Peter the Great’s priorities was to increase the social stature of his newly-created officer corps. In January 1712, he decreed that officers would enjoy a higher standing than any other noble “notwithstanding his family ancestry.”<span class="font01"><sup><span href="#/therussian_endnotes#thent74" id="theft74" title="Link target outside of Sample">74</span></sup></span> The officer corps was also opened to every estate to enhance its prestige in lower social strata. Peter’s successors underlined the importance of serving in the army and granted many privileges to the officer corps. Thus, in 1775, nobles who did not have an officer’s rank lost their voting rights in the provincial assemblies. The monarchy also perpetuated the notion of honorably serving to defend the motherland. The military was the only respected professional career for nobles.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// therussian_thehistoryof16.vue?4eb7c7fa